import http, { createApi } from '@core/fetch'

export default {
  dashboard: createApi('/p/wedding/index.php/admin/CpmBalance/dashboard'),

  upgrade_status: createApi(
    '/p/wedding/index.php/Admin/APIMerchant/upgrade_status'
  ),

  getPlanList: createApi('/p/wedding/Admin/APIADCenterWidePlan/list'),

  simplePlanList: createApi('/p/wedding/Admin/APIADCenterWidePlan/simpleList'),

  subPlanList: createApi('/p/wedding/Admin/APIADCenterWidePlan/planList'),

  getPlanDetail: createApi('/p/wedding/Admin/APIADCenterWidePlan/detail'),

  canAddNewPlan: createApi(
    '/p/wedding/Admin/APIADCenterWidePlan/canAddNewPlan'
  ),

  addPlan: body => http.post('/hms/dsp/appApi/core/plan/add', { body }),

  editPlan: body => http.post('/hms/dsp/appApi/core/plan/update', { body }),

  deletePlan: body => http.post('/hms/dsp/appApi/core/plan/delete', { body }),

  //计划单-修改出价
  updateBudget: createApi.post('/hms/dsp/appApi/core/plan/updateBudget'),

  startPlan: createApi.post('/p/wedding/Admin/APIADCenterWidePlan/start', {
    onError: false
  }),

  pausePlan: createApi.post('/p/wedding/Admin/APIADCenterWidePlan/pause', {
    onError: false
  }),
  pauseAll: createApi.post('/p/wedding/Admin/APIADCenterWidePlan/pauseAll'),
  areas: createApi('/p/wedding/Admin/APICpmPlan/areas'),

  keyword_list: createApi('/p/wedding/admin/APICpmPlan/keyword_list'),

  planDetail: createApi('/p/wedding/Admin/APIADCenterWidePlan/detail'),

  pay_check: createApi('/p/wedding/index.php/admin/CpmBalance/pay_check'),

  selectSmartMaterial: createApi(
    '/p/wedding/Admin/APIADCenterWidePlan/selectSmartMaterial'
  ),

  displayTypes: createApi('/p/wedding/Admin/APIADCenterWidePlan/displayTypes'),

  // 计算奖励金
  adStrategyRule: createApi(
    '/p/wedding/index.php/admin/APIAdStrategy/adStrategyRule'
  ),
  listTabCount: createApi('/p/wedding/Admin/APIADCenterWidePlan/listTabCount'),

  //充值 奖励比例
  rules: createApi('/p/wedding/index.php/admin/APIAdStrategy/rules'),

  //计划单-建议出价
  recommendPrice: createApi(
    '/hms/dsp/appApi/core/plan/recommend/thousandBudget'
  )
}
